export const MODEL_YEARS = {
    value: 1,
    transKey: 'SECTIONS.MODEL_YEARS',
    scrollSection: null,
};
export const MODEL_TRIMS = {
    value: 2,
    transKey: 'SECTIONS.MODEL_TRIMS',
    scrollSection: 'scroll-model-trim',
};
export const DRIVE_POWER_TRAINS = {
    value: 3,
    transKey: 'SECTIONS.DRIVE_POWER_TRAINS',
    scrollSection: 'scroll-drive-power-trains',
};
export const OPTIONS_PACKAGES = {
    value: 4,
    transKey: 'SECTIONS.PACKAGES',
    scrollSection: 'scroll-options-packages',
};
export const OPTIONS_AND_ACCESSORIES = {
    value: 5,
    transKey: 'SECTIONS.OPTIONS',
    scrollSection: 'scroll-options',
};
export const CONFIRMATION = {
    value: 6,
    transKey: 'SECTIONS.CONFIRMATION',
    scrollSection: 'scroll-summary',
};
